"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _InputField = _interopRequireDefault(require("@kiwicom/orbit-components/lib/InputField"));
var _rtl = require("@kiwicom/orbit-components/lib/utils/rtl");
var _Airplane = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Airplane"));
var _IconText2 = _interopRequireDefault(require("../IconText"));
var _ClickOutside = _interopRequireDefault(require("../ClickOutside"));
var _Theme = require("../../records/Theme");
var _AirportListData = _interopRequireDefault(require("./components/AirportListData"));
var _jsxRuntime = require("react/jsx-runtime");
var _FormattedMessage, _IconText;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Container = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "IataPicker__Container",
  componentId: "sc-18e70dv-0"
})(["position:relative;"]);
const ResultWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "IataPicker__ResultWrapper",
  componentId: "sc-18e70dv-1"
})(["position:absolute;top:74px;", ":0;width:100%;max-height:300px;overflow-y:scroll;z-index:2;box-shadow:0 0 1px rgba(0,0,0,0.16),0 1px 32px rgba(0,0,0,0.32);background:", ";"], _rtl.left, _ref => {
  let {
    theme
  } = _ref;
  return theme.orbit.paletteWhite;
});
ResultWrapper.defaultProps = {
  theme: _Theme.themeDefault
};
class IataPicker extends React.PureComponent {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      open: false
    });
    (0, _defineProperty2.default)(this, "handleInputChange", ev => {
      const target = ev.target;
      const {
        value
      } = target;
      const {
        onSelect
      } = this.props;
      onSelect(value);
    });
    (0, _defineProperty2.default)(this, "handleSelect", value => {
      const {
        onSelect
      } = this.props;
      this.setState({
        open: false
      });
      onSelect(value);
    });
    (0, _defineProperty2.default)(this, "handleFocus", () => {
      this.setState({
        open: true
      });
    });
    (0, _defineProperty2.default)(this, "handleKeyDown", ev => {
      if (ev.key === "Tab") {
        this.setState({
          open: false
        });
      }
    });
    (0, _defineProperty2.default)(this, "handleClickOutside", () => {
      this.setState({
        open: false
      });
    });
  }
  render() {
    const {
      id,
      value,
      error,
      intl,
      withIcon
    } = this.props;
    const {
      open
    } = this.state;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ClickOutside.default, {
      active: open,
      onClickOutside: this.handleClickOutside,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Container, {
        "data-test": "IATAPicker",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputField.default, {
          id: id,
          value: value,
          onChange: this.handleInputChange,
          onFocus: this.handleFocus,
          onKeyDown: this.handleKeyDown,
          label: withIcon == null ? _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "common.iata_code"
          })) : _IconText || (_IconText = /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconText2.default, {
            icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Airplane.default, {
              color: "primary",
              size: "small"
            }),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "common.iata_code"
            })
          })),
          placeholder: intl.formatMessage({
            id: "account.iata_placeholder"
          }),
          help: value === null ? "" : intl.formatMessage({
            id: "account.iata_help"
          }),
          error: error
        }), open && value !== "" && /*#__PURE__*/(0, _jsxRuntime.jsx)(ResultWrapper, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AirportListData.default, {
            value: value,
            onSelect: this.handleSelect
          })
        })]
      })
    });
  }
}
/**
 * @deprecated
 * Please use Orbit's InputField
 */
(0, _defineProperty2.default)(IataPicker, "defaultProps", {
  withIcon: true
});
var _default = exports.default = (0, _reactIntl.injectIntl)(IataPicker);